import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Image from 'react-image'
import LoadImage from 'assets/images/loading-image.gif'
import NewFile from 'assets/images/new-file-simple-md.png'
import ThumbnailLoader from 'components/shared/loaders/thumb'

const Message = ({ body, isOdd, avatar, updateAt, isAdmin }) => (
  <div className="messages-content">
    <div className={`flex w-full justify-start ${isOdd ? 'odd' : 'even flex-row-reverse'}`}>
      <div className={`avatar relative lg:w-1/12 mt-3 ${isAdmin ? 'lg:w_6' : 'lg:w-1/12'} w-2/12`}>
        <img
          alt="avatar"
          src={avatar || require('assets/images/default-profile.png')}
          className="rounded-full absolute lg:bottom-0 w-3/5 m-auto inset-x-0 top-0"
        />
      </div>
      {(body.content_type === 'text' || body.content_type === 'message') && (
        <div
          className={`max-w-75 px-5 pt-5 pb-3 rounded-lg mt-3 break-words ${
            isOdd ? 'bg-orange-100' : 'bg-gray-100'
          }`}
        >
          {(body.content || '').split('\n').map((row, index) => (
            <Fragment key={index}>
              <p className="pb-2">{row}</p>
            </Fragment>
          ))}
        </div>
      )}
      {body.content_type === 'attachment' && (
        <div
          className={`max-w-75 pt-5 flex flex-wrap ${
            isOdd ? 'justify-start' : 'justify-end'
          } rounded-lg mt-3 break-words`}
        >
          {(body.content || []).map((file, index) => {
            const isImage = file.type && file.type.indexOf('image') > -1
            return (
              <div className="max-h-max px-1 pb-2 flex" key={index}>
                {isImage && (
                  <a rel="noreferrer" target="_blank" href={file.path}>
                    <Image
                      className="h-24 w-24 object-cover rounded-lg"
                      loader={<ThumbnailLoader />}
                      key={index}
                      src={[file.path, LoadImage]}
                    />
                  </a>
                )}
                {!isImage && (
                  <a rel="noreferrer" target="_blank" href={file.path} download key={index}>
                    <div className="text-center">
                      <Image
                        className="h-8 w-auto object-cover m-auto"
                        loader={<ThumbnailLoader />}
                        src={NewFile}
                      />
                      <p className="text-xs w-24 clamp-2">{file.name}</p>
                    </div>
                  </a>
                )}
              </div>
            )
          })}
        </div>
      )}
    </div>
    <div className={`flex w-full justify-start ${isOdd ? 'odd' : 'even flex-row-reverse'}`}>
      <div className="w-1/12 mb-3 mt-1"></div>
      <div className="mb-3 mt-1 text-xs text-gray-500">
        <span>{updateAt}</span>
      </div>
    </div>
  </div>
)

Message.propTypes = {
  body: PropTypes.object,
  isOdd: PropTypes.bool,
  avatar: PropTypes.string,
  updateAt: PropTypes.string,
  isAdmin: PropTypes.bool,
}

export default Message
